module.exports = "#exp-tab-name{\r\n    margin-top: 36px;\r\n}\r\n.moreOptnsLocal{\r\nmargin-left: 40%;\r\nfont-size: 12px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selectable-tabs/expert-screen-components/expert-local-options/expert-local-options.component.css
// module id = ./src/app/components/selectable-tabs/expert-screen-components/expert-local-options/expert-local-options.component.css
// module chunks = main